import { Form } from 'antd'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import React from 'react'
import { Button } from 'src/components/Button'
import { PasswordConditions } from 'src/components/PasswordConditions'
import { PasswordInput } from 'src/components/PasswordInput'
import { usePasswordValidation } from 'src/hooks/usePasswordValidation'
import { useChangePasswordMutation } from 'src/store/APIs/misc'

import styles from './changePassword.module.scss'
import { strings } from './strings'
import { yupSync } from './validations'

interface ChangePasswordProps {
  setShowChangePassword: React.Dispatch<React.SetStateAction<boolean>>
}

export const ChangePassword: React.FC<ChangePasswordProps> = ({
  setShowChangePassword,
}) => {
  const form = useFormInstance()

  const { password, setPassword, validationStatus, invalidPassword } =
    usePasswordValidation()

  const [triggerChangePassword] = useChangePasswordMutation()

  const cancelChangePassword = () => {
    setShowChangePassword(false)
    form.resetFields(['current_password', 'password'])
    setPassword('')
  }

  const submitChangePassword = async () => {
    form.validateFields(['current_password', 'password']).then(async () => {
      const values = form.getFieldsValue()
      const body = {
        current_password: values.current_password,
        password: values.password,
      }
      await triggerChangePassword(body)
      cancelChangePassword()
    })
  }
  return (
    <>
      <h3 className={styles.changePasswordTitle}>
        {strings.changePasswordTitle}
      </h3>
      <p className={styles.changePasswordSubtitle}>{strings.note}</p>
      <Form.Item
        name="current_password"
        className={styles.leftHalfSection}
        rules={[yupSync]}>
        <PasswordInput
          required
          label={strings.currentPasswordLabel}
          placeholder={strings.passwordLabel}
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[yupSync]}
        className={styles.leftHalfSection}>
        <PasswordInput
          required
          label={strings.newPasswordLabel}
          onChange={e => setPassword(e.target.value)}
          value={password}
        />
      </Form.Item>
      <PasswordConditions validationStatus={validationStatus} />
      <div className={styles.buttonsContainer}>
        <Button onClick={cancelChangePassword}>
          {strings.cancelButtonLabel}
        </Button>
        <Button
          type="primary"
          onClick={submitChangePassword}
          disabled={invalidPassword}>
          {strings.submitButtonLabel}
        </Button>
      </div>
    </>
  )
}
